import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import {
  StyledGeneralEvent,
  StyledIconContent,
  StyledEventRow,
  StyledDate,
  StyledTitle,
  StyledDesc,
  StyledIcons,
  StyledBoxInteriorButtonMessage,
  ButtonsEvent,
  StyledTag,
  StyledIconDot
} from './styleEvent';
import { StyledIconOptions } from './style';

/** API */
import { setCMSAction, checkViewedByContent } from '../../../utils/apiHeader';

/** Utils */
import { icons } from '../../../utils/icoEvents';
import { Share } from '../../../../assets/images/index';

/** Models */
import { dataNotificationsModel } from '../../../utils/models';

/** Constants */
const STATUS = {
  VALIDATE_PENDING: 'PENDIENTE',
  VALIDATE_PENDING_GENERAL_SERVICES: 'PENDIENTE'
};

const ACTIONS = {
  VALIDATE: 'VALIDAR',
  REFUSE: 'RECHAZAR'
};

const URL_MATCHING = {
  NEWS: 'news',
  DOCUMENT: 'documents',
  EVENT: 'events'
};

class GeneralNotifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOptions: {}
    };
  }

  executeAction = (contentType, action, contentId) => {
    const { update } = this.props;
    // Execute the action
    setCMSAction(
      URL_MATCHING[contentType],
      action.toLowerCase(),
      contentId
    ).then(() => {
      // Set this notification as viewed
      checkViewedByContent(contentId).then(() => update());
    });
  };

  // TODO: Right now the URL works only for news and events
  goToContent = item => {
    const { update, location, history } = this.props;
    const { contentId, contentType } = item;
    const pathFromContentType = contentType === 'NEWS' ? 'noticia' : 'agenda';
    const pathSelected = `/${pathFromContentType}/${contentId}`;

    if (
      pathFromContentType === 'noticia' &&
      location.pathname.includes(pathFromContentType)
    ) {
      window.location.pathname = pathSelected;
    } else {
      history.push(pathSelected);
    }

    checkViewedByContent(contentId).then(() => update());
  };

  handleShowOptions(id) {
    const { showOptions } = this.state;
    this.setState({
      showOptions: {
        ...showOptions,
        [id]: showOptions[id] ? !showOptions[id] : true
      }
    });
  }

  render() {
    const { data } = this.props;
    const { showOptions } = this.state;
    return data
      ? data.map(item => (
          <StyledGeneralEvent
            key={item.id}
            tabIndex="0"
            className="notification"
          >
            <StyledIconContent>
              <StyledIcons
                size="m"
                color={item.accepted ? 'grayDarker' : 'light'}
                svg={icons(item.contentType)}
                className="notification-icon"
              />
              <StyledEventRow className="notification-row1">
                <StyledIconDot viewed={item.viewed} />
                <StyledDate className="notification-date">
                  {item.sendDate}
                </StyledDate>
                <StyledTitle className="notification-title">
                  {item.title}
                </StyledTitle>
              </StyledEventRow>
              <StyledEventRow className="notification-row2">
                <StyledDesc className="notification-description">
                  {item.description}
                </StyledDesc>
                {item.stateContent && item.viewed && (
                  <StyledTag>{STATUS[item.stateContent]}</StyledTag>
                )}
                <StyledIconOptions
                  onClick={() => this.handleShowOptions(item.id)}
                  size="l"
                  color="dark"
                  svg={Share}
                />
              </StyledEventRow>
            </StyledIconContent>
            <StyledBoxInteriorButtonMessage
              className="notification-box"
              showOptions={showOptions[item.id]}
            >
              {item.actionsUser &&
                item.actionsUser.length > 0 &&
                item.actionsUser.map(action => (
                  <ButtonsEvent
                    key={action}
                    onClick={() =>
                      this.executeAction(
                        item.contentType,
                        action,
                        item.contentId
                      )
                    }
                    ghost
                  >
                    {ACTIONS[action]}
                  </ButtonsEvent>
                ))}
              <ButtonsEvent onClick={() => this.goToContent(item)} ghost>
                VER
              </ButtonsEvent>
              <ButtonsEvent
                onClick={() => this.handleShowOptions(item.id)}
                ghost
              >
                CERRAR
              </ButtonsEvent>
            </StyledBoxInteriorButtonMessage>
          </StyledGeneralEvent>
        ))
      : false;
  }
}

GeneralNotifications.propTypes = {
  update: PropTypes.func,
  data: dataNotificationsModel
};

export default withRouter(GeneralNotifications);
